module.exports = __webpack_public_path__ + "img/mckenna.7b0dfab8.jpg";